import { render, staticRenderFns } from "./DashboardNotice.vue?vue&type=template&id=649f289c&scoped=true"
import script from "./DashboardNotice.vue?vue&type=script&lang=js"
export * from "./DashboardNotice.vue?vue&type=script&lang=js"
import style0 from "./DashboardNotice.vue?vue&type=style&index=0&id=649f289c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f289c",
  null
  
)

export default component.exports